
import { BACKGROUND_COLOR } from 'interfaces';
import styled from 'styled-components';
import { Svg } from '@/components/styled';
import { ICONS, List as IconList } from '@/public/img/icons';
import devices from '@/utilities/devices';
import { renderIcons } from '@/utilities/functions';

interface IconCardOwnProps {
	/**
	 * Text description of the grid block
	 */
	readonly description: string,
	/**
	 * Icon to display for the grid block
	 */
	readonly icon: {
		name: ICONS;
	},
	/**
	 * Title of the grid
	 */
	readonly iconCardTitle: string;
}

// #region STYLE
const IconCardContainer = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	width: 32rem;
	@media screen and (${devices.mobile}) {
		width: 100%;
		padding: 1.3rem 0;
	}

	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		width: 32rem;
		max-width: 80%;
		padding: 2rem 0;
	}
`;

const IconCardTitle = styled.h2<{ sectionColor?: BACKGROUND_COLOR }>`
	color: ${({ theme, sectionColor }) => {
		switch (sectionColor) {
			case 'beige':
				return theme.color.prune;
			case 'beigeLight':
				return theme.color.prune;
			case 'blue':
				return theme.color.black;
			case 'prune':
				return theme.color.white;
			case 'white':
				return theme.color.prune;
			default: theme.color.greyDarker;
		}
	}};
	font-size: ${({ theme }) => theme.fontSize.XXLARGE};
	font-weight: 600;
	margin: .5rem 0;
`;

const IconCardText = styled.h4<{ sectionColor?: BACKGROUND_COLOR; }>`
	color: ${({ theme, sectionColor }) => {
		switch (sectionColor) {
			case 'beige':
				return theme.color.prune;
			case 'beigeLight':
				return theme.color.black;
			case 'blue':
				return theme.color.black;
			case 'prune':
				return theme.color.white;
			case 'white':
				return theme.color.greyDarker;
		}
	}};
	font-size: ${({ theme }) => theme.fontSize.DEFAULT};
	font-weight: 400;
	line-height: 1.5rem;
	margin: 0;
	padding: 0 3.5rem;
	text-align: center;
	@media screen and (${devices.mobile}) {
		padding: 0 2.5rem;
	}
	@media screen and (${devices.minTablet}) and (${devices.maxTablet}) {
		padding: 0 3rem;
	}
`;
// #endregion

const IconCard = ({ card, sectionColor }: { card: IconCardOwnProps; sectionColor: BACKGROUND_COLOR }) => {
	return (
		<IconCardContainer>
			<Svg
				color={sectionColor === 'beige' ? 'prune' : ''}
				size={{ width: '64px', height: '64px' }}
			>
				{card.icon && renderIcons(card?.icon?.name, IconList)}
			</Svg>
			<IconCardTitle sectionColor={sectionColor}> {card.iconCardTitle} </IconCardTitle>
			<IconCardText sectionColor={sectionColor}> {card.description} </IconCardText>
		</IconCardContainer>
	);
};

export default IconCard;
